import gql from "graphql-tag";
import { useApolloClient } from "react-apollo-hooks";
import { onError } from "../utils/format-error";
import { toast } from "react-toastify";

export const SAVE_SESSION_TRACKING = gql`
  mutation saveSessionTracking($where: SessionTrackingInput!) {
    session: saveSessionTracking(where: $where)
  }
`;

export const CONFIRM_SESSION_ACTIVITY = gql`
  mutation confirmSessionActivity($where: StaffAbsencesValidateInput) {
    session: confirmSessionActivity(where: $where)
  }
`;

export const useSession = () => {
  const client = useApolloClient();
  const saveSessionTracking = async ({
    accessType,
    centerSelectedId,
    absencesType
  }) => {
    try {
      const where = { accessType, absencesType };
      if (centerSelectedId) {
        where.centerId = centerSelectedId;
      }

      const { data } = await client.mutate({
        mutation: SAVE_SESSION_TRACKING,
        variables: { where }
      });
      return data.session;
    } catch (error) {
      onError(error, toast);
    }
  };

  const confirmSessionActivity = async ({ centerSelectedId }) => {
    try {
      const where = {};
      if (centerSelectedId) {
        where.centerId = centerSelectedId;
      }

      const { data } = await client.mutate({
        mutation: CONFIRM_SESSION_ACTIVITY,
        variables: { where }
      });
      return data.session;
    } catch (error) {
      onError(error, toast);
    }
  };

  return { saveSessionTracking, confirmSessionActivity };
};
